import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EvisaDemoUI from './components/evisa-uk/evisa';
import './App.css';

const App = () => {
  return (
    <Routes>
      {/* Redirect root path to the desired route */}
      <Route path="/" element={<Navigate to="/v1/en/immigration-verification" replace />} />
      
      {/* Main Route */}
      <Route path="/v1/en/immigration-verification" element={<EvisaDemoUI />} />
    </Routes>
  );
};

export default App;

